'use strict';

module.exports = /* @ngInject */ ["$window", "authTokenProvider", function ($window, authTokenProvider) {
  return {
    request: function (config) {
      var tokenObj = authTokenProvider.get();
      if (tokenObj !== null && tokenObj.access_token !== null &&
          (config.headers.Authorization === undefined ||
          config.headers.Authorization.substr(0, 6) === 'Bearer')) {
        config.headers.Authorization = 'Bearer ' + tokenObj.access_token;
      }
      return config;
    }
  };
}];



//////////////////
// WEBPACK FOOTER
// /app/~/redi-idp-web-lib/dist/infrastructure/authInterceptor.js
// module id = 127
// module chunks = 0